<template>
    <div class="beforeCheckout" data-e2e="beforeCheckout">

        <br>

        <b-row>
          <b-col>
            <div class="d-flex align-items-center" @click="mixinGoBack()">
              <BtnBack :text="'Torna indietro'" />
            </div>
          </b-col>
        </b-row>


        <b-container fluid :class="'beforeCheckoutHead boxset-'+activeBand" v-if="boxset !== undefined">
            <b-row>
                <b-col>
                    <p>Hai selezionato il voucher:</p>
                    <BoxsetResume
                        :focus="focus"
                        :band="activeBand"
                        :nights="nights"
                        :price="boxset.public_price"
                        :bookingHidePrice="$config.guiSettings.bookingHidePrice"
                    />
                    <br>
                    <p>
                        <CopyScadenza
                            default="Dopo averlo ordinato, avrai {value} mesi per prenotare e viaggiare."
                        />
                    </p>
                    <br>
                    <p>
                        Il Salabam è acquistabile con diversi metodi di pagamento. Scopri di seguito come fare.
                    </p>
                </b-col>
            </b-row>
        </b-container>

        <br>

        <b-container>
            <b-row>
                <b-col>
                    <div class="accordion" role="tablist">

                        <div class="panel panel-gray panel-w">
                            <div class="panel-title" v-b-toggle.accordion-w>
                                <div class="panel-title-content">
                                    <div class="panel-icon-title d-flex align-items-center">
                                        <SvgBag />
                                        <span>Acquista con il credito welfare</span>
                                    </div>
                                    <SvgChevronDown class="chevronDown" />
                                </div>
                            </div>
                            <b-collapse v-model="visible1" id="accordion-w" accordion="before-checkout-accordion" role="tabpanel">
                                <div class="panel-content">
                                    <p>
                                        Accedi al portale welfare della tua azienda, acquista il tuo voucher Salabam e potrai prenotare il tuo viaggio dopo pochi istanti.
                                    </p>
                                    <div class="steplist">
                                        <div class="step">
                                            <div class="stepIcon">
                                                <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="60" cy="60" r="60" fill="white"/>
                                                    <path d="M44.0117 53.9766H44.4102C44.7826 53.9766 45.0612 53.9036 45.2461 53.7578C45.431 53.6094 45.5234 53.3945 45.5234 53.1133C45.5234 52.8294 45.4453 52.6198 45.2891 52.4844C45.1354 52.349 44.8932 52.2812 44.5625 52.2812H44.0117V53.9766ZM46.7461 53.0703C46.7461 53.6849 46.5534 54.1549 46.168 54.4805C45.7852 54.806 45.2396 54.9688 44.5312 54.9688H44.0117V57H42.8008V51.2891H44.625C45.3177 51.2891 45.8438 51.4388 46.2031 51.7383C46.5651 52.0352 46.7461 52.4792 46.7461 53.0703ZM53.0078 54.1367C53.0078 55.082 52.7734 55.8086 52.3047 56.3164C51.8359 56.8242 51.1641 57.0781 50.2891 57.0781C49.4141 57.0781 48.7422 56.8242 48.2734 56.3164C47.8047 55.8086 47.5703 55.0794 47.5703 54.1289C47.5703 53.1784 47.8047 52.4531 48.2734 51.9531C48.7448 51.4505 49.4193 51.1992 50.2969 51.1992C51.1745 51.1992 51.8451 51.4518 52.3086 51.957C52.7747 52.4622 53.0078 53.1888 53.0078 54.1367ZM48.8398 54.1367C48.8398 54.7747 48.9609 55.2552 49.2031 55.5781C49.4453 55.901 49.8073 56.0625 50.2891 56.0625C51.2552 56.0625 51.7383 55.4206 51.7383 54.1367C51.7383 52.8503 51.2578 52.207 50.2969 52.207C49.8151 52.207 49.4518 52.3698 49.207 52.6953C48.9622 53.0182 48.8398 53.4987 48.8398 54.1367ZM55.4023 53.8242H55.793C56.1758 53.8242 56.4583 53.7604 56.6406 53.6328C56.8229 53.5052 56.9141 53.3047 56.9141 53.0312C56.9141 52.7604 56.8203 52.5677 56.6328 52.4531C56.4479 52.3385 56.1602 52.2812 55.7695 52.2812H55.4023V53.8242ZM55.4023 54.8086V57H54.1914V51.2891H55.8555C56.6315 51.2891 57.2057 51.431 57.5781 51.7148C57.9505 51.9961 58.1367 52.4245 58.1367 53C58.1367 53.3359 58.0443 53.6354 57.8594 53.8984C57.6745 54.1589 57.4128 54.3633 57.0742 54.5117C57.9336 55.7956 58.4935 56.625 58.7539 57H57.4102L56.0469 54.8086H55.4023ZM61.6758 57H60.4648V52.2969H58.9141V51.2891H63.2266V52.2969H61.6758V57ZM67.6016 57L67.1875 55.6406H65.1055L64.6914 57H63.3867L65.4023 51.2656H66.8828L68.9062 57H67.6016ZM66.8984 54.625C66.5156 53.3932 66.2995 52.6966 66.25 52.5352C66.2031 52.3737 66.1693 52.2461 66.1484 52.1523C66.0625 52.4857 65.8164 53.3099 65.4102 54.625H66.8984ZM69.6289 57V51.2891H70.8398V56H73.1562V57H69.6289ZM77.4414 57H74.1523V51.2891H77.4414V52.2812H75.3633V53.5352H77.2969V54.5273H75.3633V56H77.4414V57ZM48.0703 68H46.6914L45.918 65C45.8893 64.8932 45.8398 64.6732 45.7695 64.3398C45.7018 64.0039 45.6628 63.7786 45.6523 63.6641C45.6367 63.8047 45.5977 64.0312 45.5352 64.3438C45.4727 64.6536 45.4245 64.875 45.3906 65.0078L44.6211 68H43.2461L41.7891 62.2891H42.9805L43.7109 65.4062C43.8385 65.9818 43.931 66.4805 43.9883 66.9023C44.0039 66.7539 44.0391 66.5247 44.0938 66.2148C44.151 65.9023 44.2044 65.6602 44.2539 65.4883L45.0859 62.2891H46.2305L47.0625 65.4883C47.099 65.6315 47.1445 65.8503 47.1992 66.1445C47.2539 66.4388 47.2956 66.6914 47.3242 66.9023C47.3503 66.6992 47.3919 66.4466 47.4492 66.1445C47.5065 65.8398 47.5586 65.5938 47.6055 65.4062L48.332 62.2891H49.5234L48.0703 68ZM53.5312 68H50.2422V62.2891H53.5312V63.2812H51.4531V64.5352H53.3867V65.5273H51.4531V67H53.5312V68ZM54.7266 68V62.2891H55.9375V67H58.2539V68H54.7266ZM60.4414 68H59.25V62.2891H62.5234V63.2812H60.4414V64.7539H62.3789V65.7422H60.4414V68ZM67.1367 68L66.7227 66.6406H64.6406L64.2266 68H62.9219L64.9375 62.2656H66.418L68.4414 68H67.1367ZM66.4336 65.625C66.0508 64.3932 65.8346 63.6966 65.7852 63.5352C65.7383 63.3737 65.7044 63.2461 65.6836 63.1523C65.5977 63.4857 65.3516 64.3099 64.9453 65.625H66.4336ZM70.375 64.8242H70.7656C71.1484 64.8242 71.431 64.7604 71.6133 64.6328C71.7956 64.5052 71.8867 64.3047 71.8867 64.0312C71.8867 63.7604 71.793 63.5677 71.6055 63.4531C71.4206 63.3385 71.1328 63.2812 70.7422 63.2812H70.375V64.8242ZM70.375 65.8086V68H69.1641V62.2891H70.8281C71.6042 62.2891 72.1784 62.431 72.5508 62.7148C72.9232 62.9961 73.1094 63.4245 73.1094 64C73.1094 64.3359 73.0169 64.6354 72.832 64.8984C72.6471 65.1589 72.3854 65.3633 72.0469 65.5117C72.9062 66.7956 73.4661 67.625 73.7266 68H72.3828L71.0195 65.8086H70.375ZM77.7344 68H74.4453V62.2891H77.7344V63.2812H75.6562V64.5352H77.5898V65.5273H75.6562V67H77.7344V68Z" fill="#E7775A"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M39.9716 20H80.0662C82.3357 20 84.0378 21.7021 84.0378 23.9716V96.2175C84.0378 98.2979 82.3357 100 80.0662 100H39.9716C37.7021 100 36 98.2979 36 96.2175V23.9716C36 21.7021 37.7021 20 39.9716 20ZM56.2364 23.9716H63.8014C64.9362 23.9716 64.9362 25.4846 63.8014 25.4846H56.2364C55.1017 25.4846 55.1017 23.9716 56.2364 23.9716ZM55.8582 92.2459H64.1797C66.6383 92.2459 66.6383 96.0284 64.1797 96.0284H55.8582C53.3995 96.0284 53.3995 92.2459 55.8582 92.2459ZM39.2151 29.4563H80.8227V88.2742H39.2151V29.4563Z" fill="#E7775A"/>
                                                </svg>                                    
                                            </div>
                                            <p>1. Accedi al tuo portale welfare e cerca Salabam</p>
                                        </div>
                                        <div class="arrow"><SvgArrowRight /></div>
                                        <div class="step">
                                            <div class="stepIcon">
                                                <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="60" cy="60" r="60" fill="white"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M39.9716 20H80.0662C82.3357 20 84.0378 21.7021 84.0378 23.9716V96.2175C84.0378 98.2979 82.3357 100 80.0662 100H39.9716C37.7021 100 36 98.2979 36 96.2175V23.9716C36 21.7021 37.7021 20 39.9716 20ZM56.2364 23.9716H63.8014C64.9362 23.9716 64.9362 25.4846 63.8014 25.4846H56.2364C55.1017 25.4846 55.1017 23.9716 56.2364 23.9716ZM55.8582 92.2459H64.1797C66.6383 92.2459 66.6383 96.0284 64.1797 96.0284H55.8582C53.3995 96.0284 53.3995 92.2459 55.8582 92.2459ZM39.2151 29.4563H80.8227V88.2742H39.2151V29.4563Z" fill="#E7775A"/>
                                                    <path d="M67.3416 66.8893C67.7807 66.4502 68.2198 65.9483 68.5334 65.3838C69.098 64.4428 69.3489 63.2509 69.3489 61.8708C69.3489 60.8044 69.1607 59.8635 68.7216 59.1107C68.2825 58.3579 67.7807 57.6679 67.0906 57.166C66.4006 56.6642 65.6478 56.2251 64.8323 55.9114C64.0168 55.5978 63.1386 55.3468 62.3231 55.1587C60.8803 54.845 59.8766 54.5314 59.2493 54.2804C58.622 54.0295 58.3084 53.5904 58.3084 52.9631C58.3084 52.3358 58.622 51.8339 59.1866 51.583C59.7512 51.3321 60.3785 51.2066 61.0685 51.2066C61.9467 51.2066 62.825 51.3948 63.5777 51.7712C64.3932 52.1476 65.0833 52.6494 65.6478 53.214L69.6626 49.0738C68.5962 48.0701 67.2161 47.2546 65.6478 46.7528C64.0796 46.2509 62.4486 46 60.8176 46C59.7512 46 58.6847 46.1254 57.6183 46.4391C56.5519 46.69 55.5482 47.1291 54.67 47.7564C53.7917 48.321 53.039 49.1365 52.4744 50.0148C51.9098 50.9557 51.6589 52.0849 51.6589 53.4022C51.6589 54.4059 51.8471 55.3469 52.2235 56.0369C52.5999 56.7897 53.1017 57.417 53.729 57.9188C54.3563 58.4207 55.0464 58.797 55.7991 59.1107C56.5519 59.4243 57.3047 59.6125 58.1202 59.8007C59.6257 60.1771 60.7549 60.4908 61.4449 60.8044C62.1349 61.1181 62.5113 61.6199 62.5113 62.31C62.5113 63 62.1976 63.5018 61.6331 63.8155C61.0685 64.0664 60.5039 64.2546 59.8766 64.2546C58.8102 64.2546 57.8065 64.0037 56.8655 63.5646C55.9246 63.0627 55.1091 62.4981 54.4818 61.8081L50.4043 66.0738C50.8434 66.5129 51.408 66.8893 51.9098 67.2657C54.4191 66.3874 57.1792 65.8856 60.0648 65.8856C62.6368 65.7601 65.0833 66.1365 67.3416 66.8893Z" fill="#E87A5F"/>
                                                    <path d="M60 69.0218C66.5867 69.0218 72.5461 70.7783 77 73.6639C73.1734 69.3354 67.0258 66.5126 60 66.5126C53.0369 66.5126 46.8266 69.3354 43 73.6639C47.5166 70.7783 53.476 69.0218 60 69.0218Z" fill="#E87A5F"/>
                                                </svg>                                    
                                            </div>
                                            <p>2. Acquista il tuo voucher Salabam</p>
                                        </div>
                                        <div class="arrow"><SvgArrowRight /></div>
                                        <div class="step">
                                            <div class="stepIcon">
                                                <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="60" cy="60" r="60" fill="white"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M39.9716 20H80.0662C82.3357 20 84.0378 21.7021 84.0378 23.9716V96.2175C84.0378 98.2979 82.3357 100 80.0662 100H39.9716C37.7021 100 36 98.2979 36 96.2175V23.9716C36 21.7021 37.7021 20 39.9716 20ZM56.2364 23.9716H63.8014C64.9362 23.9716 64.9362 25.4846 63.8014 25.4846H56.2364C55.1017 25.4846 55.1017 23.9716 56.2364 23.9716ZM55.8582 92.2459H64.1797C66.6383 92.2459 66.6383 96.0284 64.1797 96.0284H55.8582C53.3995 96.0284 53.3995 92.2459 55.8582 92.2459ZM39.2151 29.4563H80.8227V88.2742H39.2151V29.4563Z" fill="#E7775A"/>
                                                    <path d="M60.5003 52.6842C62.8984 52.6842 64.8424 50.7402 64.8424 48.3421C64.8424 45.944 62.8984 44 60.5003 44C58.1022 44 56.1582 45.944 56.1582 48.3421C56.1582 50.7402 58.1022 52.6842 60.5003 52.6842Z" fill="#E7775A"/>
                                                    <path d="M60.4998 77C61.9386 77 63.1051 75.8335 63.1051 74.3947C63.1051 72.9558 61.9386 71.7894 60.4998 71.7894C59.0609 71.7894 57.8945 72.9558 57.8945 74.3947C57.8945 75.8335 59.0609 77 60.4998 77Z" fill="#E7775A"/>
                                                    <path d="M69.7108 53.4601C70.4303 53.4601 71.0135 52.8769 71.0135 52.1575C71.0135 51.4381 70.4303 50.8549 69.7108 50.8549C68.9914 50.8549 68.4082 51.4381 68.4082 52.1575C68.4082 52.8769 68.9914 53.4601 69.7108 53.4601Z" fill="#E7775A"/>
                                                    <path d="M51.2895 73.6187C52.9681 73.6187 54.329 72.2579 54.329 70.5793C54.329 68.9006 52.9681 67.5398 51.2895 67.5398C49.6108 67.5398 48.25 68.9006 48.25 70.5793C48.25 72.2579 49.6108 73.6187 51.2895 73.6187Z" fill="#E7775A"/>
                                                    <path d="M73.5259 63.1053C74.4851 63.1053 75.2627 62.3277 75.2627 61.3684C75.2627 60.4092 74.4851 59.6316 73.5259 59.6316C72.5667 59.6316 71.7891 60.4092 71.7891 61.3684C71.7891 62.3277 72.5667 63.1053 73.5259 63.1053Z" fill="#E7775A"/>
                                                    <path d="M47.4737 64.8421C49.3922 64.8421 50.9474 63.2869 50.9474 61.3685C50.9474 59.45 49.3922 57.8948 47.4737 57.8948C45.5552 57.8948 44 59.45 44 61.3685C44 63.2869 45.5552 64.8421 47.4737 64.8421Z" fill="#E7775A"/>
                                                    <path d="M69.7101 72.7503C70.9092 72.7503 71.8812 71.7783 71.8812 70.5793C71.8812 69.3802 70.9092 68.4082 69.7101 68.4082C68.5111 68.4082 67.5391 69.3802 67.5391 70.5793C67.5391 71.7783 68.5111 72.7503 69.7101 72.7503Z" fill="#E7775A"/>
                                                    <path d="M51.2888 56.0654C53.447 56.0654 55.1967 54.3158 55.1967 52.1575C55.1967 49.9993 53.447 48.2496 51.2888 48.2496C49.1305 48.2496 47.3809 49.9993 47.3809 52.1575C47.3809 54.3158 49.1305 56.0654 51.2888 56.0654Z" fill="#E7775A"/>
                                                </svg>
                                            </div>
                                            <p>3. Prenota online il tuo viaggio</p>
                                        </div>
                                    </div>

                                </div>
                            </b-collapse>
                        </div>

                        <div class="panel panel-gray panel-cc">
                            <div class="panel-title" v-b-toggle.accordion-cc>
                                <div class="panel-title-content">                                    
                                    <div class="panel-icon-title d-flex align-items-center">
                                        <SvgCreditCardGroup />
                                        <span>Acquista con la carta di credito</span>
                                    </div>
                                    <SvgChevronDown class="chevronDown" />
                                </div>
                            </div>
                            <b-collapse v-model="visible2" id="accordion-cc" accordion="before-checkout-accordion" role="tabpanel">
                                <div class="panel-content">
                                    <p>
                                        Clicca sul tasto Continua. Dovrai prima inserire i tuoi dati personali e poi potrai scegliere di pagare con la tua carta di credito.
                                    </p>
                                    <br>
                                    <div class="text-left">
                                        <div class="d-flex">
                                            <div>
                                                <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M31.3093 7.45022H22.3638C23.7181 6.77011 24.8709 5.7477 25.708 4.48444C26.5063 3.21142 26.6576 1.96593 26.114 1.07138C25.8561 0.680712 25.4889 0.374553 25.0582 0.191021C24.6275 0.0074898 24.1523 -0.0453059 23.6919 0.0392062C20.444 0.293809 17.5676 3.72751 16.1707 5.70241C14.7739 3.72751 11.8975 0.293809 8.64963 0.0392062C8.18923 -0.0434012 7.71474 0.0102769 7.28443 0.193646C6.85413 0.377014 6.48676 0.682086 6.22746 1.07138C5.68384 1.96593 5.83523 3.21142 6.63345 4.48444C7.47056 5.7477 8.62344 6.77011 9.97769 7.45022H1.03218C0.758425 7.45022 0.495887 7.55897 0.302317 7.75254C0.108747 7.94611 0 8.20865 0 8.4824V14.469C0 14.7428 0.108747 15.0053 0.302317 15.1989C0.495887 15.3924 0.758425 15.5012 1.03218 15.5012H1.27302V31.9678C1.27302 32.2416 1.38176 32.5041 1.57533 32.6977C1.7689 32.8913 2.03144 33 2.30519 33H30.0363C30.3101 33 30.5726 32.8913 30.7662 32.6977C30.9597 32.5041 31.0685 32.2416 31.0685 31.9678V15.5012H31.3093C31.5831 15.5012 31.8456 15.3924 32.0392 15.1989C32.2327 15.0053 32.3415 14.7428 32.3415 14.469V8.4824C32.3415 8.34685 32.3148 8.21263 32.2629 8.0874C32.211 7.96217 32.135 7.84839 32.0392 7.75254C31.9433 7.6567 31.8295 7.58067 31.7043 7.52879C31.5791 7.47692 31.4449 7.45022 31.3093 7.45022ZM30.2771 9.51457V13.4368H20.1274V9.51457H30.2771ZM23.857 2.09668C23.9073 2.09125 23.9578 2.08895 24.0084 2.08979C24.1236 2.07921 24.2397 2.09815 24.3456 2.14484C24.4006 2.2343 24.3937 2.7091 23.9258 3.43162C23.2481 4.35602 22.3725 5.11743 21.363 5.66028C20.3535 6.20314 19.2355 6.51375 18.0906 6.56943C19.4599 4.70464 21.717 2.2687 23.857 2.09668ZM8.41567 3.43162C7.94775 2.7091 7.94087 2.2343 7.98904 2.15172C8.0954 2.09847 8.21484 2.07697 8.3331 2.08979C8.38365 2.08895 8.43421 2.09125 8.48448 2.09668C10.6245 2.2687 12.8815 4.70464 14.2509 6.56943C13.106 6.51375 11.988 6.20314 10.9785 5.66028C9.96899 5.11743 9.0934 4.35602 8.41567 3.43162ZM2.06435 9.51457H12.2141V13.4368H2.06435V9.51457ZM3.33737 15.687H12.2141V30.9356H3.33737V15.687ZM29.0041 30.9356H20.1274V15.687H29.0041V30.9356Z" fill="#E7775A"/>
                                                </svg>
                                            </div>
                                            <p v-if="this.$config.guiSettings.giftCardsEnabled">
                                                Potrai anche decidere di regalare questo Salabam scegliendo se spedirlo per email o se inviare scatolina regalo e card al destinatario: senza costi di spedizione!
                                            </p>
                                        </div>
                                    </div>
                                    <br/><br/>
                                    <p class="m-auto d-flex align-items-center justify-content-center text-center">
                                        <strong class="mr-4 pr-4">Acquista con la carta di credito</strong>
                                        <router-link :to="{name: 'checkout'}">
                                            <b-button size="sm" data-e2e="goToCheckoutButton">Continua</b-button>
                                        </router-link>
                                    </p>
                                </div>
                            </b-collapse>
                        </div>

                        <div class="panel panel-gray panel-tc" v-if="mixinUseTicketCompliments()">
                            <div class="panel-title" v-b-toggle.accordion-tc>
                                <div class="panel-title-content">                                    
                                    <div class="panel-icon-title d-flex align-items-center">
                                        <SvgEdenred />
                                        <span>Acquista con Ticket Compliments</span>
                                    </div>
                                    <SvgChevronDown class="chevronDown" />
                                </div>
                            </div>
                            <b-collapse v-model="visible3" id="accordion-tc" accordion="before-checkout-accordion" role="tabpanel">
                                <div class="panel-content">
                                    <p>
                                        Clicca sul tasto Continua. Dovrai prima inserire i dati personali e poi potrai scegliere di pagare usando i tuoi Ticket Compliments.
                                    </p>
                                    <br>
                                    <p class="m-auto d-flex align-items-center justify-content-center text-center">
                                        <strong class="mr-4 pr-4">Usa i tuoi Ticket Compliments</strong>
                                        <b-button size="sm" v-b-modal.edenredLogin>Continua</b-button>
                                    </p>
                                </div>
                                <b-modal size="lg" id="edenredLogin" title="Login Edenred" hide-footer>
                                    <iframe :src="this.$config.endpoints.etcSso" />
                                </b-modal>
                            </b-collapse>
                        </div>

                        <div class="panel panel-gray panel-scp" v-if="mixinUseScalapay()">
                            <div class="panel-title" v-b-toggle.accordion-scp>
                                <div class="panel-title-content">                                    
                                    <div class="panel-icon-title d-flex align-items-center">
                                        <img src="/assets/pagamenti/scalapay.svg" />
                                        <span>Acquista con Scalapay</span>
                                    </div>
                                    <SvgChevronDown class="chevronDown" />
                                </div>
                            </div>
                            <b-collapse v-model="visible4" id="accordion-scp" accordion="before-checkout-accordion" role="tabpanel">
                                <div class="panel-content">
                                    <p>
                                        Clicca sul tasto Continua. Dovrai prima inserire i dati personali e poi potrai scegliere di pagare con Scalapay.
                                    </p>
                                    <br>
                                    <p class="m-auto d-flex align-items-center justify-content-center text-center">
                                        <strong class="mr-4 pr-4">Acquista con Scalapay</strong>
                                        <router-link :to="{name: 'checkout'}" >
                                            <b-button size="sm" data-e2e="goToCheckoutButton">Continua</b-button>
                                        </router-link>
                                    </p>
                                    <br/>
                                    <p class="text-center">Visita <a href="https://www.scalapay.com" target="_blank">www.scalapay.com</a> per tutte le condizioni</p>
                                </div>
                            </b-collapse>
                        </div>

                        <div class="panel panel-gray panel-stp" v-if="mixinUseSatispay()">
                            <div class="panel-title" v-b-toggle.accordion-stp>
                                <div class="panel-title-content">                                    
                                    <div class="panel-icon-title d-flex align-items-center">
                                        <img src="/assets/pagamenti/satispay.svg" />
                                        <span>Acquista con Satispay</span>
                                    </div>
                                    <SvgChevronDown class="chevronDown" />
                                </div>
                            </div>
                            <b-collapse v-model="visible5" id="accordion-stp" accordion="before-checkout-accordion" role="tabpanel">
                                <div class="panel-content">
                                    <p>
                                        Clicca sul tasto Continua. Dovrai prima inserire i dati personali e poi potrai scegliere di pagare con la tua app Satispay.
                                    </p>
                                    <br>
                                    <p class="m-auto d-flex align-items-center justify-content-center text-center">
                                        <strong class="mr-4 pr-4">Acquista con Satispay</strong>
                                        <router-link :to="{name: 'checkout'}" >
                                            <b-button size="sm" data-e2e="goToCheckoutButton">Continua</b-button>
                                        </router-link>
                                    </p>
                                </div>
                            </b-collapse>
                        </div>
                    </div>
                </b-col>
            </b-row>

            
            <br>

            <p class="text-center small">
                <!--
                    
                    *Sono spesso presenti delle promozioni che prolungano la validità standard di 12 mesi.
                    <br>
                -->
                La data esatta di scadenza del tuo Salabam è indicata precisamente nell'email Salabam che ricevi pochi istanti dopo l'acquisto.
            </p>

        </b-container>

        <br>

        <b-row v-if="visible1 || visible2 || visible3 || visible4 || visible5">
            <b-col>
                <div class="d-flex align-items-center justify-content-end" @click="mixinGoTo('search',{})">
                    <BtnBack :text="'Torna ai risultati'" />
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import BoxsetResume from '../blocks/boxset/boxset-resume'
import SvgArrowRight from '../svg/arrow-right'
import SvgCreditCardGroup from '../svg/credit-card-group'
import SvgEdenred from '../svg/etc-logo-transparent'
import SvgBag from '../svg/bag'
import SvgChevronDown from '../svg/chevron-down'
import CopyScadenza from '@/components/blocks/common/copy-scadenza'
import BtnBack from '@/components/atoms/btn-back'

export default {
    name: 'before-checkout', // chiamata anche pagina di disambiguazione
    components:
    {
        BoxsetResume, SvgArrowRight,
        SvgCreditCardGroup, SvgBag, SvgChevronDown, SvgEdenred,
        CopyScadenza,
        BtnBack,
    },
    props:
    {
    },
    data()
    {
        return {
            focus: '',
            nights: 0,
            activeBand: '',
            boxset: {},
            visible1: false,
            visible2: false,
            visible3: false,
            visible4: false,
            visible5: false
        }
    },
    mounted()
    {
        this.focus = this.$store.state.focus
        this.nights = this.$store.state.dates.nights
        this.activeBand = this.$store.state.activeBand
        let boxsetId = this.$store.state.bookingData.boxset_id

        let band = Object.values(this.$config.boxsetsConfig[this.focus][this.activeBand])

        var boxset = band.filter(function (el) {
            return el.boxset_id == boxsetId
        })[0]

        this.boxset = boxset

        this.$bvModal.hide('edenredLogin')
        window.addEventListener('message', this.onIframeMessage)
    },
    methods: {
        onIframeMessage(message) {
            
            // il messaggio può non contenere un campo data
            if(message.data == undefined) return

            // il messaggio può contenere un campo data che per coincidenza arriva da altre componenti
            if(message.data.from == undefined) return

            if(message.data.from == 'loginEdenred')
            {
                //this.$bvModal.hide('edenredLogin')
                //window.console.log('ESITO LOGIN EDENRED')
                //window.console.log(message.data)
                //window.console.log(message.data.data.redirectTo)
                window.location.href = '/?token='+message.data.data.token
                //window.location.href = message.data.data.redirectTo
            }
        },
    },
}
</script>

<style lang="scss">
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/mixins";
    @import './../../scss/_custom.scss';

    .beforeCheckout
    {
        margin-bottom:0rem;
        .beforeCheckoutHead
        {
            text-align:center;
            padding-top:2rem;
            padding-bottom:2rem;
            p
            {
                margin-bottom:0;
                @include media-breakpoint-up(lg)
                {
                    font-size: 18px;
                }
            }
        }
        .boxsetResume
        {
            margin-top:1.5rem;
            margin-bottom:1rem;
            display:flex;
            justify-content:center;
            align-items:center;
            font-size: 26px;
            &>*
            {
                margin:0 8px;
            }
        }
        .col-lg-6,
        .panel
        {
            min-height: 100%;
        }
        .panelTop
        {
            text-align:center;
            strong
            {
                display:block;
                font-size:26px;
                margin-bottom:2rem;
            }
            p
            {
                display:block;
                //font-size:20px;
                margin:auto;
                margin-bottom:3rem;
                //max-width: 500px;
            }
        }
        .steplist
        {
            margin:2rem auto;
            max-width: 550px;
            .step
            {
                width:100%;
                text-align:center;
                p
                {
                    //margin-top:1rem;
                    font-weight: 500;
                }
            }
            .stepIcon
            {
                margin-bottom:0.5rem;
            }
            @include media-breakpoint-up(lg)
            {
                display:flex;
                justify-content:center;
                font-size: 13px;
                display: flex;
                .step
                {
                    max-width: 25%;
                    min-height: 100%;
                    height: inherit;
                    flex:1;
                }
                .stepIcon
                {
                    display:flex;
                    min-height:120px;
                    align-items: center;
                    justify-content: center;
                }
            }
            .arrow
            {
                display:none;
                *
                {
                    fill:$primary;
                }
                text-align:center;
                @include media-breakpoint-up(lg)
                {
                    display:block;
                    flex:1;
                    min-height: 100%;
                    display:flex;
                    align-items: center;
                    justify-content:center;
                    //transform:translateY(-100%);
                    svg
                    {
                        width:40px;
                        height:auto;
                        transform:translateY(-100%);
                    }
                }
            }
        }
    }

    .beforeCheckout
    {
        .accordion
        {
            max-width: 800px;
            margin:auto
        }
        .panel
        {
            padding:0;

            &-tc {

                .panel-icon-title {
                    svg {
                        width: 140px;
                    }
                }
            }

            &-scp, &-stp {
                a:link, a:visited {
                    color: $light-blue;
                }

                .panel-icon-title {
                    img {
                        width: 120px;
                    }
                }
            }
        }
        
        .panel-title
        {
            font-size: 18px;
            padding: 0.75rem 1.2rem 0.75rem 1.2rem;
            text-align: left;

            .panel-title-content
            {
                margin: 0 auto; 
                display:flex;
                align-items: center;
                justify-content: space-between;
            }
            &.not-collapsed .chevronDown
            {
                transform:rotate(180deg);
            }
            span
            {
                display:block;
                padding:0 1rem;
            }
            svg
            {
                transition: $transition-base;
                flex:1;
                height:auto;
                width: 30px;

                &.chevronDown {
                    max-width: 17px;
                }
            }
            @include media-breakpoint-up(lg)
            {
                font-size: 22px;
                padding: 1rem 1.25rem;
            }          
        }
        .panel-content
        {
            //padding-top:0;
            max-width:700px;
            margin:0 auto;
            text-align:left;
            @include media-breakpoint-up(lg)
            {
                padding-left: calc(32px + 1rem);
            }
        }
        #accordion-cc
        {
            svg
            {
                min-width:30px;
                height:auto;
                margin-right:1rem;
            }
        }
    }

    #edenredLogin
    {
        .modal-content 
        {
            height: 90vh;
            max-height: 600px;
        }
        iframe
        {
            width:100%;
            height:100%;
            border:0;
            padding:0;
            margin:0;
        }
    }

    @include media-breakpoint-up(lg)
    {
        #app.before-checkout #appHeader
        {
            display:none;
        }
    }
</style>